import Glide from "@glidejs/glide";
let glide = null;

function initProductSlider(id) {
    glide = new Glide('#' + id, {
        type: 'slider',
        rewind: false, 
        bound: true,
        startAt: 0,
        gap: 20,
        perView: 2,
        breakpoints: {
            900: {
                perView: 1,
                gap: 10,
            },
            1920: {
                perView: 2,
                gap: 20,
            }
            
        }
    });
    
    glide.mount();
}

export function moveGlide(whichWay) {
    glide.go(whichWay);
}

window.initProductSlider = initProductSlider;